import * as z from 'zod'

import { CreateAiTagVars, UpdateAiTagVars } from '@/common/api/params/aiTag'
import { NameLabelMapping } from '@/common/app/message'
import { AITagCategory, AITagMaster } from '@/common/model/recommend/aiTag'

export const IMPORTANCE_CHOICES = [
  { name: '高', value: 0.8 },
  { name: '中', value: 0.5 },
  { name: '低', value: 0.2 }
] as const

export const tagSchema = z.object({
  tag_name: z
    .string()
    .min(1, 'タグ名を入力してください')
    .max(50, 'タグ名は50文字以内で入力してください'),
  tag_category: z.string().min(1, 'カテゴリを選択してください'),
  importance_score: z.number().min(0).max(1)
})

export type TagFormSchemaType = z.infer<typeof tagSchema>

export const TAG_FORM_DEFAULT: TagFormSchemaType = {
  tag_name: '',
  tag_category: AITagCategory.FEATURE,
  importance_score: 0.5
}

const snapToNearestChoice = (score: number): number => {
  const values = IMPORTANCE_CHOICES.map((c) => c.value)
  return values.reduce((prev, curr) =>
    Math.abs(curr - score) < Math.abs(prev - score) ? curr : prev
  )
}

export const convertTagToSchema = (tag: AITagMaster): TagFormSchemaType => ({
  tag_name: tag.tag_name,
  tag_category: tag.tag_category,
  importance_score: snapToNearestChoice(tag.importance_score)
})

export const convertSchemaToCreateVars = (
  data: TagFormSchemaType,
  siteId: number
): CreateAiTagVars => ({
  site_id: siteId,
  tag_name: data.tag_name,
  tag_category: data.tag_category,
  importance_score: data.importance_score
})

export const convertSchemaToUpdateVars = (
  data: TagFormSchemaType,
  siteId: number,
  tagId: number
): UpdateAiTagVars => ({
  site_id: siteId,
  tag_id: tagId,
  tag_name: data.tag_name,
  tag_category: data.tag_category,
  importance_score: data.importance_score
})

export const tagNameLabelMapping: NameLabelMapping = {
  tag_name: 'タグ名',
  tag_category: 'タグカテゴリ',
  importance_score: '重要度'
}
